module.exports = __webpack_public_path__ + "img/u0.9de33c28.jpg";